import React from 'react';

const DarkBG = ({ children }) => {
  return (
    <div className="dark-bg">
      {children}
    </div>
  );
};

export default DarkBG;
